import {
  ChangeDetectionStrategy,
  Component,
  Input,
  NgModule,
  ViewEncapsulation,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TranslocoModule } from '@ngneat/transloco';
import { LetModule } from '@ngrx/component';
import { Page } from '@nx-icilalune/data/icilalune/types';

@Component({
  selector: 'i2l-ui-activity-description',
  template: `
    <ng-container *transloco="let t">
      <ng-container *ngIf="page">
        <ng-container *ngIf="showTitle">
          <h2 class="title" [innerHTML]="page.title"></h2>
        </ng-container>
        <ng-container *ngIf="showBody">
          <div class="summary" [innerHTML]="page.description"></div>
        </ng-container>
      </ng-container>
    </ng-container>
  `,
  styleUrls: ['./activity-description.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ActivityDescriptionComponent {
  @Input()
  showTitle = true;
  @Input()
  showBody = true;

  @Input()
  page: Page | undefined;
}

@NgModule({
  imports: [CommonModule, RouterModule, TranslocoModule, LetModule],
  declarations: [ActivityDescriptionComponent],
  exports: [ActivityDescriptionComponent],
})
export class ActivityDescriptionComponentModule {}
